$(function(){
	$('.more_btn').click(function() {
	    $(this).hide();
	    //$(this).next('.more_content').slideToggle();
	    $(this).next('.more_content').fadeIn();
	})

});

